import * as _ from 'lodash';
import './show-offers-button.less';

export default angular.module('cian.newbuild.filter.showOffersButton', [])
  .directive('showOffersButton', () => ({
    restrict: 'E',
    template: require('./show-offers-button.jade'),
    bindToController: {
      /**
       * reloadSame = true -> обновляем выдачу всегда
       * reloadSame = false -> обновляем только если что-то изменилось
       */
      reloadSame: '@?',
    },
    controller: ['$log', '$scope', '$timeout', '$window', 'MetaService', 'ShowOffersService', function ($log, $scope, $timeout, $window, MetaService, ShowOffersService) {
      const ctrl = this;
      let preloaderTimeout;
      const TIMEOUT = 200;

      const updateState = () => {
        ctrl.count = _.get(MetaService.lastMeta, 'count');
        ctrl.isNewQuery = urlHasChanged();
      };
      updateState();

      ctrl.onClick = event => {
        event.preventDefault();
        if (ctrl.reloadSame || ctrl.isNewQuery) {
          ShowOffersService.updateOffers();
        }
      };

      ctrl.pluralForms = {
        0: 'Найдено 0 объектов',
        one: 'Показать {$ showOffersButton.count | number $} объект',
        few: 'Показать {$ showOffersButton.count | number $} объекта',
        many: 'Показать {$ showOffersButton.count | number $} объектов',
      };

      MetaService.onRequest(() => {
        preloaderTimeout = $timeout(() => (ctrl.isLoading = true), TIMEOUT);
      });

      MetaService.onReceive(() => {
        $timeout.cancel(preloaderTimeout);
        ctrl.isLoading = false;
        updateState();
      });

      function urlHasChanged() {
        const metaUrl = _.get(MetaService.lastMeta, 'fullUrl');
        return !!metaUrl && metaUrl !== $window.location.href;
      }

      return ctrl;
    }],
    controllerAs: 'showOffersButton',
  }))
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/show-offers-button/show-offers-button.dir.js